import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from '../Button/Button'
import update from 'react-addons-update'
import { Field } from '../Field/Field'
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'
import {polyglot} from '../../../index'
import { ReactModal } from '../ReactModal/ReactModal'
import './style.css'
import moment from 'moment/moment'
import RichTextViewer from '../RichTextViewer/RichTextViewer'

const dateFormat = {
  standartData: 'YYYY-MM-DD'
}

class SingleLineTable extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      elements: {},
      deleteClicked: false
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.openModalForEdit = this.openModalForEdit.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.renderSavedContent = this.renderSavedContent.bind(this)
    this.updateState = this.updateState.bind(this)
    this.getSavedDataForElement = this.getSavedDataForElement.bind(this)
  }

  toggleModal () {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    }, () => {
      if (!this.state.modalIsOpen) {
        this.clearClickedElement()
      }
    })
  }

  clearClickedElement () {
    this.setState({
      clickedElement: undefined,
      clickedElementKey: undefined,
      deleteClicked: false,
      elements: {}
    })
  }

  openModalForEdit (key) {
    if (this.props.data) {
      const data = this.props.data[key]
      const _data = data && data !== null ? data : {}
      this.setState({
        elements: _data,
        clickedElement: data || null,
        clickedElementKey: key
      })
    }
    this.toggleModal()
  }

  getHoverBoxText ({date, doctor}) {
    return <div>
      <h4>{doctor}</h4>
      <hr />
      <h5>{date}</h5>
    </div>
  }

  renderSavedContent () {
    if (this.props.data) {
      return Object.keys(this.props.data).map((element, index) => {
        return <div key={index}>
          <CustomTooltip toolTipText={this.getHoverBoxText(this.props.data[element])}>
            <div key={element} className={'single-line-table-cell'}>
              <h5 className={'multiple-line-support'}>
                <RichTextViewer elementKey={element} handleElementClick={this.openModalForEdit} content={this.props.data[element].description} />
              </h5>
            </div>
          </CustomTooltip>
        </div>
      })
    }
  }

  handleChange (key, data) {
    this.toggleModal()
    this.setState({
      clickedElement: undefined,
      clickedElementKey: undefined
    })
    this.props.handleChange(key, data)
  }

  handleSubmit (e) {
    e.preventDefault()
    this.toggleModal()
    const result = this.state.elements
    result['doctor'] = this.props.doctorName
    if (this.state.clickedElementKey) {
      this.props.handleChange(this.state.clickedElementKey, this.state.elements)
    } else {
      this.props.handleSubmit(this.state.elements)
    }
    this.clearClickedElement()
  }

  updateState (name, value) {
    let updated
    if (value === '') {
      updated = update(this.state.elements, {
        [name]: {$set: null}
      })
    } else {
      updated = update(this.state.elements, {
        [name]: {$set: value}
      })
    }
    this.setState({
      elements: updated
    })
  }

  getSavedDataForElement (name) {
    if (this.state.clickedElement) {
      return this.state.clickedElement[name]
    }
  }

  deleteEntry (key) {
    this.props.handleChange(key, null)
    this.toggleModal()
    this.clearClickedElement()
  }

  renderDeleteButton () {
    if (this.state.clickedElement) {
      return <Fragment>
        {this.state.deleteClicked
          ? <Button
            onClick={() => { this.deleteEntry(this.state.clickedElementKey) }}
            text={'Confirm Delete'}
            buttonType={'btn btn-info'}
            type={'button'} />
          : null
        }
        <Button
          onClick={() => { this.setState({deleteClicked: true}) }}
          text={'Delete'}
          buttonType={'btn btn-danger'}
          type={'button'} />
      </Fragment>
    }
  }

  render () {
    return <div>
      {this.renderSavedContent()}
      <Button text={this.props.insertionButtonText} buttonType='btn-block btn-default' type='button' onClick={this.toggleModal} />
      <ReactModal
        footer={this.renderDeleteButton()}
        fullWidth
        name={this.props.nameOfModal}
        toggleModal={() => { this.openModalForEdit(undefined) }}
        modalIsOpen={this.state.modalIsOpen}>
        <div className='form-horizontal'>
          <form onSubmit={e => this.handleSubmit(e)}>
            {this.props.config.elements.map(element => {
              return <Field
                expandInputArea
                getValue={this.updateState}
                minDateForCalendar={this.props.minDateForCalendar}
                maxDateForCalendar={moment().format(dateFormat.standartData)}
                savedData={this.getSavedDataForElement(element.name)}
                required={!element.optional}
                key={element.label}
                label={element.label}
                elements={element.elements}
                name={element.name}
                type={element.type} />
            })}
            <Button type='submit' text={polyglot.t('staticFields.commonFields.save')} buttonType='btn-primary btn-block' />
          </form>
        </div>
      </ReactModal>
    </div>
  }
}

SingleLineTable.propTypes = {
  data: PropTypes.object,
  doctorName: PropTypes.string,
  config: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  insertionButtonText: PropTypes.string.isRequired,
  nameOfModal: PropTypes.string.isRequired,
  insertionFieldDescription: PropTypes.string.isRequired,
  minDateForCalendar: PropTypes.string,
  maxDateForCalendar: PropTypes.string
}

export { SingleLineTable }



// WEBPACK FOOTER //
// ./src/components/common/SingleLineTable/SingleLineTable.js